export const cleanObject = <T extends object>(
  obj: T,
  exceptions: Array<keyof T | (string & {})> = []
): Partial<T> => {
  const result: Partial<T> = {};
  const exceptionSet = new Set<string>(exceptions.map((key) => String(key)));

  for (const [key, value] of Object.entries(obj)) {
    const k = key as keyof T;

    if (exceptionSet.has(key)) {
      if (value !== undefined) {
        result[k] = value as T[typeof k];
      }
      continue;
    }

    if (value !== undefined && value !== null && value !== '') {
      result[k] = value as T[typeof k];
    }
  }

  return result;
};
